import { createOpenStore } from "stores/createOpenStore";

export interface ColumnDescriptionOpen {
  tableId: string;
  columnId: string;
  columnName?: string;
  /** Gates the Edit affordance inside the overlay. The opener knows it; the
   *  single mount does not, so it travels with the request. */
  canEdit: boolean;
  mode: "read" | "edit";
  /** What the overlay aligns to — a column row in the details pane, a slot on
   *  the action bar. Omitted ⇒ pinned to the top of the details panel. */
  anchor?: HTMLElement | null;
  /** `"above"` is what a bottom-docked opener needs: the panel hangs over the
   *  anchor instead of beside it. Absent is `DetailsOverlay`'s own default. */
  side?: "above";
}

export const useColumnDescriptionStore =
  createOpenStore<ColumnDescriptionOpen>();
